export default function ModalLoading({loading = false, onClick = null}) {

    if (!loading) {
        return null
    }

    return (
        <div className="modal-loading" onClick={() => {
            if (onClick) {
                onClick();
            }
        }}>
            <div className="loader">

            </div>
        </div>
    )
}
